var map = {
	"./ar.webp": "./src/assets/landing/spreadsheet-main/ar.webp",
	"./da.webp": "./src/assets/landing/spreadsheet-main/da.webp",
	"./de.webp": "./src/assets/landing/spreadsheet-main/de.webp",
	"./en.webp": "./src/assets/landing/spreadsheet-main/en.webp",
	"./es-419.webp": "./src/assets/landing/spreadsheet-main/es-419.webp",
	"./es.webp": "./src/assets/landing/spreadsheet-main/es.webp",
	"./fr.webp": "./src/assets/landing/spreadsheet-main/fr.webp",
	"./it.webp": "./src/assets/landing/spreadsheet-main/it.webp",
	"./ja.webp": "./src/assets/landing/spreadsheet-main/ja.webp",
	"./nb.webp": "./src/assets/landing/spreadsheet-main/nb.webp",
	"./nl.webp": "./src/assets/landing/spreadsheet-main/nl.webp",
	"./pl.webp": "./src/assets/landing/spreadsheet-main/pl.webp",
	"./pt.webp": "./src/assets/landing/spreadsheet-main/pt.webp",
	"./sv.webp": "./src/assets/landing/spreadsheet-main/sv.webp",
	"./tr.webp": "./src/assets/landing/spreadsheet-main/tr.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/landing/spreadsheet-main sync recursive ^\\.\\/.*\\.webp$";